import { render, staticRenderFns } from "./SlideInIcon.vue?vue&type=template&id=23db3a2e&"
import script from "./SlideInIcon.vue?vue&type=script&lang=js&"
export * from "./SlideInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports